// apps/web/src/app/store/umumkan.ts
/**
 * A sentence a screen asks the shell to read out in its polite live region (PindahHalaman), as
 * the selection's count of the bulk actions (spec 2026-10-02-aksi-massal, 4.2): fixed words with
 * a number, never anything typed. No React here.
 */
import { create } from 'zustand'

export interface UmumkanState {
  kalimat: string
  /** Bumped on every request: the same sentence twice is read twice. */
  nomor: number
  umumkan: (kalimat: string) => void
}

export const useUmumkan = create<UmumkanState>((set) => ({
  kalimat: '',
  nomor: 0,
  umumkan: (kalimat) => set((s) => ({ kalimat, nomor: s.nomor + 1 })),
}))
